export const PRIZES_METHODS = {
  mailCheck: 'mailCheck',
  cashapp: 'cashapp',
  crypto: 'crypto',
  venmo: 'venmo',
  games: 'games',
  paypal: 'paypal'
}
